import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

import { FormGroup, FormBuilder, Validators } from "@angular/forms";
// import data from "../field.json";
import { Inject } from "@angular/core";
// import { FieldLayoutComponent } from "../field-layout/field-layout.component";

export interface FieldProperties {
  readonly: boolean;
  required: boolean;
}

@Component({
  selector: "app-globalaction-fielddialog",
  templateUrl: "./globalaction-fielddialog.component.html",
  styleUrls: ["./globalaction-fielddialog.component.scss"],
})
export class GlobalactionFielddialogComponent implements OnInit {
  @Input() closable = false;
  @Input() visible: boolean = true;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() editEvent = new EventEmitter<any>();
  @Output() fieldPropertiesChanged: EventEmitter<FieldProperties> =
    new EventEmitter<FieldProperties>();

  detailForm: FormGroup;
  inputField: any[] = [];

  selectedFields: string[] = [];
  readonly: boolean;
  required: boolean;

  constructor(
    private dialogRef: MatDialogRef<GlobalactionFielddialogComponent>,
    // private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  fieldProperties: FieldProperties = {
    readonly: false,
    required: false,
  };
  ngOnInit() {
    if (this.data && this.data.fieldProperties) {
      this.fieldProperties = { ...this.data.fieldProperties };
    }

    console.log("Data", this.data);
  }

  ok() {
    this.dialogRef.close(this.fieldProperties);
    this.fieldPropertiesChanged.emit(this.fieldProperties);
    console.log("Result *** ", this.fieldProperties);
    this.dialogRef.close(this.fieldProperties);
  }

  close() {
    this.dialogRef.close();
  }
}
